import classNames from 'classnames';
import styles from './index.module.scss';
import { LoadingPlaceholder } from '../../../../../../../components/LoadingPlaceholder/index';
import { QRCodeHeader } from './QRCodeHeader';
import { QRSteps } from './QRSteps';

export const QRCodeContent = ({ qrBase64Code }: { qrBase64Code?: string }) => {
  return (
    <div className={classNames(styles.qrCodeWrapper, 'flex flex-col')}>
      <QRCodeHeader />
      <div className="flex justify-center gap-4 flex-wrap sm:flex-nowrap">
        <QRSteps />
        <LoadingPlaceholder isLoading={!qrBase64Code}>
          <div className="flex justify-center shrink-0">
            <img
              data-testid="qrBase64Code"
              alt="qrBase64Code"
              className={styles.qrCodeImage}
              src={'data:image/png;base64,' + qrBase64Code}
            />
          </div>
        </LoadingPlaceholder>
      </div>
    </div>
  );
};
